import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom'
import * as H from 'history';

import Footer from './components/footer/Footer';

import { resetApplication } from './store/applicationActions';

import * as logService from './services/log';
import Icon from './components/shared/icon/Icon';

interface IOwnState {
    hasError: boolean;
}

interface IDispatchProps {
    resetApplication: typeof resetApplication;
}

type Props = IDispatchProps;

class ErrorBoundary extends React.Component<Props, IOwnState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            hasError: false
        }
    }

    public componentDidCatch(error: Error | null, info: object) {
        this.setState({
            hasError: true
        });

        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            global.console.log(`Error: ${error}`);
            global.console.log(`Info: ${info}`);
        } else {
            logService.error(error, info);
        }
    }

    public render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        return <React.Fragment>
            <header className="main-header main-header--bordered">
                <div className="w--lg">
                    <div className="flex-grid">
                        <div className="flex-grid__col flex-grid__col--3 flex-grid__col--md-2">
                            <a href="/" className="button button--logo">
                                <Icon name="logo" isV2={true} />
                            </a>
                        </div>
                    </div>
                </div>
            </header>
            <section className="section">
                <div className="deck">
                    <div className="w--md banner-title">
                        <h2>Ups!</h2>
                        <Route render={({ history }) => (
                            <p>Noget gik galt og indholdet kan ikke vises.<br /><br /><a href="/#" onClick={this.componentCleanup(history)}>Gå til startsiden</a></p>
                        )} />
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>;
    }

    private componentCleanup = (history: H.History) => (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        this.props.resetApplication();

        this.setState({
            hasError: false
        }, () => {
            history.push('/');
        });
    }
}

const mapDispatchToProps = (dispatch: any): IDispatchProps => ({
    resetApplication: () => dispatch(resetApplication())
});

const container = connect(null, mapDispatchToProps)(ErrorBoundary);

export default container;